import { render } from "./WorkAreaTable.vue?vue&type=template&id=48106590"
import script from "./WorkAreaTable.vue?vue&type=script&lang=ts"
export * from "./WorkAreaTable.vue?vue&type=script&lang=ts"
script.render = render

export default script